var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57323 7.54803L10.5 1.61804L12.4268 7.54803C12.5339 7.87765 12.841 8.10081 13.1876 8.10081H19.4228L14.3784 11.7657L14.6723 12.1703L14.3784 11.7658C14.098 11.9695 13.9807 12.3306 14.0878 12.6602L16.0146 18.5902L10.9702 14.9252C10.6898 14.7215 10.3102 14.7215 10.0298 14.9252L4.98542 18.5902L6.91219 12.6602C7.01929 12.3306 6.90196 11.9695 6.62157 11.7657L1.57722 8.10081H7.81238C8.15897 8.10081 8.46613 7.87764 8.57323 7.54803ZM16.5126 18.952L16.512 18.9516L16.5126 18.952Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cd7b9a1f49da19db5f03eed1d741a66e.svg";
export { ForwardRef as ReactComponent };